import { Box } from "@mui/material"
import { isNil } from "lodash"
import { useState } from "react"
import BaseItem from "./BaseItem"
import { ItemLightDto } from "./ItemDataTypes"


export interface ItemSharedProps {
    additionalOnClick?: () => void
    isObtained?: boolean,
}
export interface ItemProps extends ItemSharedProps {
    id: string,
    image: string
    title?: string,
    isMajor?: boolean,
    onClick?: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void
    onRightClick?: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void
    item?: ItemLightDto
    updateItem?: (i: ItemLightDto) => void
    tooltip?: string
    displayName?: boolean
    imageComponent?: (props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => JSX.Element,
    childItem?: string,
    displayChildItem?: true
    setIsObtained?: (v: boolean) => void
}


const Item = (props: ItemProps) => {

    let [isObtained, setIsObtained] = useState(props.isObtained ?? false);

    let [isWoth, setIsWoth] = useState(false);

    const handleWoth = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        if (e.ctrlKey || e.shiftKey) {
            setIsWoth(!isWoth);
        }
    }

    const handleClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        if (e.type === 'contextmenu')
            e.preventDefault();


        if (!isNil(props.setIsObtained))
            props.setIsObtained(!props.isObtained);
        setIsObtained(!isObtained)

        if (!isNil(props.updateItem) && !isNil(props.item)){
            props.updateItem({ ...props.item, isObtained: !props.item?.isObtained })
}
        if (!isNil(props.additionalOnClick))
            props.additionalOnClick();
    }

    const handleRightClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        e.preventDefault();
        if (isNil(props.onRightClick)) {
            if (!isNil(props.updateItem) && !isNil(props.item))
                props.updateItem({ ...props.item, isObtained: !props.item?.isObtained })
        }
        else
            props.onRightClick(e);
    }

    const setIsObtainedFacto = (v: boolean) => {
        
        if (!isNil(props.setIsObtained))
            props.setIsObtained(v);
        setIsObtained(v)

        if (!isNil(props.updateItem) && !isNil(props.item))
            props.updateItem({ ...props.item, isObtained: !props.item?.isObtained })
    }

    

    return <Box className="woth" display="flex" sx={{ border: isWoth ? "solid yellow 1px " : "inherit" }}>
        <BaseItem
            id={props.id}
            image={props.image}
            title={props.title}
            tooltip={props.tooltip}
            displayName={props.displayName}
            onClick={(e) => {
                if (!isNil(props.onClick)) {
                    props.onClick(e)
                }
                else {
                    handleClick(e)
                }
                handleWoth(e);
            }} onRightClick={props.onRightClick ?? handleRightClick}
            isObtained={props.item?.isObtained ?? isObtained}
            item={{...props.item, img: props.image }}
            updateItem={props.updateItem}
            setIsObtained={setIsObtainedFacto}
            imageComponent={props.imageComponent}
            childItemImg={props.childItem}
            displayChildItem={props.displayChildItem}

        />
    </Box>

}

export default Item